module.exports = __webpack_public_path__ + "static/ValtellinaPalace_plani_1591-4loc-73-9b6e09a2bf63b660642ecd3b679c844e.jpg";